
export class LocalStorageKey {
    public static readonly TOKEN = 'token';
    public static readonly USER_ID = 'userId';
    public static readonly ISLOGGEDIN = 'isLoggedIn'
    public static readonly CONNECTIVITY = 'connectivity'
}

export enum ModulePermissions {
    ManageDashboard = 'Manage Dashboard',
    ManageCalendar = 'Manage Calendar',
    ManageLocation = 'Manage Location',
    ManageBoard = 'Manage Board',
    ManageSchool = 'Manage School',
    ManageSection = 'Manage Section',
    ManageSubject = 'Manage Subject',
    ManageClass = 'Manage Class',
    ManageClassRoom = 'Manage Class Room',
    ManageTimingSet = 'Manage Timing Set',
    ManageTimetable = 'Manage Timetable',
    ManageSyllabus = 'Manage Syllabus',
    ManageStudyMaterial = 'Manage EContent',
    ManageAssignment = 'Manage Assignment',
    ManageAssignmentRemark = 'Manage Assignment Remark',
    ManageGradeSet = 'Manage Grade Set',
    ManageExam = 'Manage Exam',
    GiveExam = 'Give Exam',
    ManageExamMark = 'Manage Exam Mark',
    ManageStudentAssessment = 'Manage Student Assessment',
    ManageResultConfiguration = 'Manage Result Configuration',
    GenerateResult = 'Generate Result',
    DownloadResult = 'Download Result',
    CanMoveStudent = 'Can Move Student',
    ManagePrincipal = 'Manage Principal',
    ManageAdmin = 'Manage Admin',
    ManageFaculty = 'Manage Faculty',
    ManageFacultyAssignment = 'Faculty Assignment',
    ManageStudent = 'Manage Student',
    ManageBonafide = 'Manage Bonafide Certificate',
    ManageInternalAssessment = 'Manage Internal Assessment',
    ManageDriver = 'Manage Driver',
    ManageAgent = 'Manage Agent',
    ManageUserDocument = 'Manage User Document',
    ManageManualAttendance = 'Manage Manual Attendance',
    ApplyLeave = 'Apply Leave',
    ApproveLeave = 'Approve Leave',
    ManageHoliday = 'Manage Holiday',
    ManageDiscount = 'Manage Discount',
    ManageFees = 'Manage Fees',
    ManageFeesPayment = 'Manage Fees Payment',
    PayFees = 'Pay Fees',
    ManageBank = 'Manage Bank',
    ManagePTM = 'Manage PTM',
    ManageBook = 'Manage Book',
    IssueBook = 'Issue Book',
    ManageBookAuthor = 'Manage Book Author',
    ManageBookPublication = 'Manage Book Publication',
    ManageBookCategory = 'Manage Book Category',
    ManageTask = 'Manage Task',
    ManageAdditionDeduction = 'Manage Addition Deduction',
    GeneratePayslip = 'Generate Payslip',
    DownloadPayslip = 'Download Payslip',
    ManageStoreCategory = 'Manage Store Category',
    ManageStoreType = 'Manage Store Type',
    ManageItemCategory = 'Manage Item Category',
    ManageStoreItem = 'Manage Store Item',
    ManageSupplierType = 'Manage Supplier Type',
    ManageSupplier = 'Manage Supplier',
    ManageItemRequest = 'Manage Item Request',
    ManagePurchaseOrder = 'Manage Purchase Order',
    ManageGRN = 'Manage GRN',
    ManageBillingAndInvoice = 'Manage Billing and Invoice',
    GenerateInventoryReport = 'Generate Inventory Report',
    GenerateIDCard = 'Generate ID Card',
    ManageNotes = 'Manage Notes',
    ManageComplaint = 'Manage Complaint',
    ManageMeeting = 'Manage Meeting',
    ManageHostel = 'Manage Hostel',
    ManageNoticeBoard = 'Manage Notice Board',
    ManageDailyExpense = 'Manage Daily Expense',
    ManageDailyIncome = 'Manage Daily Income',
    ManageVisitorLog = 'Manage Visitor Log',
    ManageAuditLog = 'Manage Audit Log',
    ManageOpinionPoll = 'Manage Opinion Poll',
    AnswerOpinionPoll = 'Answer Opinion Poll',
    ManageFeedback = 'Manage Feedback',
    FillFeedback = 'Fill Feedback',
    ManageAttendanceWeeklyReport = 'Manage Attendance Weekly Report',
    ManageAssignmentWeeklyReport = 'Manage Assignment Weekly Report',
    ManageAssignmentReport = 'Manage Assignment Report',
    ManageExamReport = 'Manage Exam Report',
    ManageStudentIndividualReport = 'Manage Student Individual Report',
    ManageFeesReport = 'Manage Fees Report',
    ManageNotificationSetting = 'Manage Notification Setting',
    ManageGeneralSetting = 'Manage General Setting',
    ManageAcademicYear = 'Manage Academic Year',
    ManagePermissionSet = 'Manage Permission Set',
    ManageBeaconGateway = 'Manage Beacon Gateway',
    ManageMail = 'Manage Mail',
    ManageActivity = 'Manage Activity',
    ManageReportCard = "Manage Report Card",
    ManageInquiry = 'Manage Inquiry',
    ManageBus = 'Manage Bus',
    ManageTransportFees = 'Manage Transport Fees',
    ManageSeminarWorkshop = 'Manage Seminar And Workshops',
    ManageEvent = 'Manage Event',
    ManageAppBanner = 'Manage App Banner',
    ManagePost = 'Manage Post',
    ManageImageTemplate = 'Manage Image Template',
    ManageChat = 'Manage Chat',
    ManageStudentProfileUpdate = 'Manage Student Profile Update',
}


export enum UserRole {
    SuperAdmin = 1,
    Institute = 2,
    Branch = 3,
    Principal = 4,
    AdminAndManagement = 5,
    Faculty = 6,
    Student = 7,
    Driver = 8,
}
export enum UserRoleName {
    SuperAdmin = 'Super Admin',
    Institute = 'Institute',
    Branch = 'Branch',
    Principal = 'Principal',
    AdminAndManagement = 'Admin And Management',
    Faculty = 'Faculty',
    Student = 'Student',
    Driver = 'Driver',
    Parent = 'Parent'
}
export enum Gender {
    Male = 1,
    Female = 2,
    Other = 3
}
export enum NoticeBoardStatus {
    Pending = 1,
    Approved = 2,
    Rejected = 3
}

export enum EventStatus {
    Pending = 1,
    Approved = 2,
    Rejected = 3
}
export enum TypeOfMembership {
    Convenor = 1,
    Member = 2,
}
export enum IsConvenor {
    Yes = 1,
    No = 0,
}
export class Permission {
    index?: number
    label?: string
    name?: string
    access?: string
}
export enum MessageStatus {
    UnRead = 1,
    Read = 2,
    Other = 3
}
export enum CalculationType {
    Average = 1,
    Highest = 2,
    Flat = 3
}

export enum Months {
    Jan = 1,
    Feb = 1,
    Mar = 1,
    Apr = 1,
    May = 1,
    Jun = 1,
    Jul = 1,
    Aug = 1,
    Sep = 1,
    Oct = 1,
    Nov = 1,
    Dec = 1,
}

export enum InquiryStatus {
    Lead = 1,
    OnProcess = 2,
    Converted = 3,
    NotConverted = 4
}

export enum FeesType {
    Lumpsum = 1,
    PartPayment = 2,
    JodoOnline = 3
}



// class to get response when create - update api
export class ManageModuleResponse {
    status: number
    data: string
}
export class DataToDelete {
    Id: number;
    Name: string;
}
export class PermissionSet {
    Id: number;
    RoleId: number;
    AccessJson: any;
    BranchId: number;
    Name: string;
    CreatedBy: number;
    UpdatedBy: number;
    CreatedOn: Date | string;
    UpdatedOn: Date | string;
}

// class for file attachments for every module
export class Attachment {
    filename: string;
    content: string;
    encoding: string
    module?: string;
    fileurl?: string;
    index?: number;
    isFileDeleted?: boolean
}

export class ModuleSetupModal {
    Index: number
    IsTourDone: boolean
    ComponentImage: string
    ComponentDetailTitle: string
    ComponentDescription: string
    ComponentFeatureTitle: string
    ComponentFeaturesCard: FeaturesCard[]
    Module: string
}

export class FeaturesCard {
    CardTitle: string
    CardDescription: string
    CardImage = "assets/media/project-logos/6.png"
}

export class SetupAssistantModal {
    Index: number
    Title: string
    Content: string
    IsVisited: boolean
    Module: string
    IsCreated: boolean
    Icon: string
}
export const SetupAssistantData: SetupAssistantModal[] = [{
    Index: 1,
    Title: "Create Section",
    Content: "Selecting this option allows you to add, delete or edit the list of sections as per your requirements.",
    IsVisited: false,
    Module: 'Sections',
    IsCreated: false,
    Icon: 'assets/media/svg/bnspur/sections.svg'
},
{
    Index: 2,
    Title: "Create Subject",
    Content: "This enables you to add, delete or edit the list of subjects, and add the study materials for the students.",
    IsVisited: false,
    Module: 'Subjects',
    IsCreated: false,
    Icon: 'assets/media/svg/bnspur/sections.svg'
},
{
    Index: 3,
    Title: "Create Classes",
    Content: "Going ahead with this option will help you add or modify the list of classes and enroll the students accordingly.",
    IsVisited: false,
    Module: 'Classes',
    IsCreated: false,
    Icon: 'assets/media/svg/bnspur/class.svg'
},
{
    Index: 4,
    Title: "Create Principal",
    Content: "This allows you to create a specific profile of the principal of the school that enables parents to contact her directly in case of any need",
    IsVisited: false,
    Module: 'Principals',
    IsCreated: false,
    Icon: 'assets/media/svg/bnspur/principals.svg'
},
{
    Index: 5,
    Title: "Create Admin",
    Content: "Selecting this option enables you to create a particular profile of the one who administers the school, and all the queries will get responded here.",
    IsVisited: false,
    Module: 'Admin And Management',
    IsCreated: false,
    Icon: 'assets/media/svg/bnspur/admin-and-management.svg'
},
{
    Index: 6,
    Title: "Create Faculties",
    Content: "Create a profile for each one of your faculties including the detail of which subject they teach and which class they manage.",
    IsVisited: false,
    Module: 'Faculties',
    IsCreated: false,
    Icon: 'assets/media/svg/bnspur/faculties.svg'
},
{
    Index: 7,
    Title: "Create Students",
    Content: "Enroll the students of your school and create their profiles that provide information like their class, section, roll number, and their academic report.",
    IsVisited: false,
    Module: 'Students',
    IsCreated: false,
    Icon: 'assets/media/svg/bnspur/students.svg'
}]

// export enum SidebarMenuNames {
// }

export enum StarRatingColor {
    primary = "primary",
    accent = "accent",
    warn = "warn"
}

export class IdNameModel {
    id: number;
    name: string;
}

export class EditIdNameModel {
    Id: number;
    Name: string;
}

export class classRoomBulkDelete {
    Id: number;
    RoomNo: string;
}
export enum Action {
    Class = 1,
    Section = 2,
    Subject = 3,
}

export class IdModel {
    Id: number;
}

export enum UserStatus {
    'PasswordResetRequired' = 1,
    'PasswordUpdated' = 2,
    'Activated' = 3,
    'Blocked' = 4
}

export enum WorkFlowStatus {
    'Submitted' = 1,
    'Not Submitted' = 2,
    'Improper' = 3,
    'Incomplete' = 4,
    'Present' = 5,
    'Absent' = 6,
    'Draft' = 7,
    'Live' = 8,
    'Cancelled' = 9,
    'Not Attempted' = 10,
    'Attempted' = 11,
    'Pending' = 12,
    'In Progress' = 13,
    'Resolved' = 14,
}

export enum TaskPriority {
    Highest = 1,
    High = 2,
    Medium = 3,
    Low = 4,
    Lowest = 5,
}

export enum Category {
    Seminar = 1,
    Function = 2,
    Workshops = 3,
}

export enum Weekdays {
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
    Sunday = 7,
}

export enum AttendanceNotes {
    None = 0,
    Present = 1,
    PresentButNotAttentive = 2,
    VideoOff = 3,
    Absent = 4,
    OnLeave = 5,
}
export enum AttendanceDayCategory {
    Full = 0,
    FirstHalf = 1,
    SecondHalf = 2,
}

export enum StudentAssessmentType {
    Current = 1,
    Overall = 2
}

export enum PaymentStatus {
    Pending = 1,
    Paid = 2,
    PDC = 3,
    Failed = 4,
}
export enum PaymentMethod {
    Cheque = 1,
    Cash = 2,
    Online = 3,
}
export enum SubjectPreference {
    Educational = 1,
    NonEducational = 2
}
export enum SubjectType {
    Compulsory = 1,
    Optional = 2,
    Additional = 3,
    Practical = 4
}
export enum ExamTypeReportCard {
    Internal = 1,
    HalfYearly = 2,
    Yearly = 3
}

export enum helpVideoURL {

    // for location model 
    LocationVideo = "https://www.youtube-nocookie.com/embed/qaunqtmPzBA",
    LocationTitle = "How to create Location?",
    LocationSVG = './assets/media/svg/bnspur/store-type.svg',

    // for board model 
    BoardVideo = "https://www.youtube-nocookie.com/embed/yLa5anzVxAs",
    BoardTitle = "How to create Board?",
    BoardSVG = './assets/media/svg/bnspur/store-type.svg',

    // for school model 
    SchoolVideo = "https://www.youtube-nocookie.com/embed/sSYxJ-clmm0",
    SchoolTitle = "How to create previous school?",
    SchoolSVG = './assets/media/svg/bnspur/store-type.svg',

    // for Section model 
    SectionVideo = "https://www.youtube-nocookie.com/embed/T5acRJrBftY",
    SectionTitle = "How to create Section?",
    SectionSVG = './assets/media/svg/bnspur/sections.svg',

    // for Subject model 
    SubjectVideo = "https://www.youtube-nocookie.com/embed/0cPnthjw4bk",
    SubjectTitle = "How to create Subject?",
    SubjectSVG = './assets/media/svg/bnspur/sections.svg',

    // for Class model 
    ClassVideo = "https://www.youtube-nocookie.com/embed/kFO4rJEtR_U",
    ClassTitle = "How to create Class?",
    ClassSVG = './assets/media/svg/bnspur/class.svg',

    // for ClassRoom model 
    ClassRoomVideo = "https://www.youtube-nocookie.com/embed/nI1lk-enMwE",
    ClassRoomTitle = "How to create Class Room?",
    ClassRoomSVG = './assets/media/svg/bnspur/ClassRoom.svg',

    // for TimeSets model 
    TimeSetsVideo = "https://www.youtube-nocookie.com/embed/fqiG-aJ2Skg",
    TimeSetsTitle = "How to create Time Sets for timetable?",
    TimeSetsSVG = './assets/media/svg/bnspur/TimeSets.svg',

    // for TimeTable model 
    TimeTableVideo = "https://www.youtube-nocookie.com/embed/cuvjiMlNbP8",
    TimeTableTitle = "How to create timetable?",
    TimeTableSVG = './assets/media/svg/bnspur/TimeTable.svg',

    // for Syllabus model 
    SyllabusVideo = "",
    SyllabusTitle = "How to create Syllabus?",
    SyllabusSVG = './assets/media/svg/bnspur/Syllabus.svg',

    // for StudyMaterial model 
    StudyMaterialVideo = "https://www.youtube-nocookie.com/embed/E3OOxhDQz1c",
    StudyMaterialTitle = "How to create Study Material?",
    StudyMaterialSVG = './assets/media/svg/bnspur/study-material.svg',

    // for Assignment model 
    AssignmentVideo = "https://www.youtube.com/embed/xmpTqJPdepY",
    AssignmentTitle = "How to create Assignment?",
    AssignmentSVG = './assets/media/svg/bnspur/study-material.svg',

    // for AssignmentRemarks model 
    AssignmentRemarksVideo = "https://www.youtube.com/embed/RViR4TX_T2s",
    AssignmentRemarksTitle = "How to create Assignment Remarks?",
    AssignmentRemarksSVG = './assets/media/svg/bnspur/study-material.svg',


}

export enum helpPDF {
    // for Section model 
    SectionURL = "https://doc.app.eduwity.com/HelpPDF/Sections.pdf",
    SectionTitle = "How to create Section?",
    SectionSVG = './assets/media/svg/bnspur/sections.svg',

    // for Location model 
    LocationURL = "https://doc.app.eduwity.com/HelpPDF/Location.pdf",
    LocationTitle = "How to create Location?",
    LocationSVG = './assets/media/svg/bnspur/store-type.svg',

    // for Board model 
    BoardURL = "https://doc.app.eduwity.com/HelpPDF/Board.pdf",
    BoardTitle = "How to create Board?",
    BoardSVG = './assets/media/svg/bnspur/store-type.svg',

    // for School model 
    SchoolURL = "https://doc.app.eduwity.com/HelpPDF/School.pdf",
    SchoolTitle = "How to create School?",
    SchoolSVG = './assets/media/svg/bnspur/store-type.svg',

    // for Subject model 
    SubjectURL = "https://doc.app.eduwity.com/HelpPDF/Subjects.pdf",
    SubjectTitle = "How to create Subject?",
    SubjectSVG = './assets/media/svg/bnspur/store-type.svg',

    // for Class model 
    ClassURL = "https://doc.app.eduwity.com/HelpPDF/Classes.pdf",
    ClassTitle = "How to create Class?",
    ClassSVG = './assets/media/svg/bnspur/class.svg',

    // for ClassRoom model 
    ClassRoomURL = "https://doc.app.eduwity.com/HelpPDF/Class%20Room.pdf",
    ClassRoomTitle = "How to create Class Room?",
    ClassRoomSVG = './assets/media/svg/bnspur/ClassRoom.svg',

    // for TimeSets model 
    TimeSetsURL = "https://doc.app.eduwity.com/HelpPDF/TimetableTimingset.pdf",
    TimeSetsTitle = "How to create Time Sets for timetable?",
    TimeSetsSVG = './assets/media/svg/bnspur/TimeSets.svg',

    // for TimeTable model 
    TimeTableURL = "https://doc.app.eduwity.com/HelpPDF/Timetable.pdf",
    TimeTableTitle = "How to create timetable?",
    TimeTableSVG = './assets/media/svg/bnspur/TimeTable.svg',

    // for Syllabus model 
    SyllabusURL = "",
    SyllabusTitle = "How to create Syllabus?",
    SyllabusSVG = './assets/media/svg/bnspur/Syllabus.svg',

    // for StudyMaterial model 
    StudyMaterialURL = "https://doc.app.eduwity.com/HelpPDF/Study%20material.pdf",
    StudyMaterialTitle = "How to create Study Material?",
    StudyMaterialSVG = './assets/media/svg/bnspur/study-material.svg',

    // for Assignment model 
    AssignmentURL = "https://doc.app.eduwity.com/HelpPDF/Assignments.pdf",
    AssignmentTitle = "How to create Assignment?",
    AssignmentSVG = './assets/media/svg/bnspur/study-material.svg',

    // for AssignmentRemarks model 
    AssignmentRemarksURL = "https://doc.app.eduwity.com/HelpPDF/Assignments%20remarks.pdf",
    AssignmentRemarksTitle = "How to create Assignment Remarks?",
    AssignmentRemarksSVG = './assets/media/svg/bnspur/study-material.svg',
}